// Veloura Nails — Interactions v2

(function() {
  'use strict';

  // ── Scroll Reveal ──
  function initReveal() {
    var items = document.querySelectorAll(
      '.card-wrapper, .featured-collection__title, .vlr-trust-item, .multicolumn-card'
    );
    items.forEach(function(el, i) {
      el.classList.add('vlr-reveal');
      var delay = i % 4;
      if (delay > 0) el.classList.add('vlr-reveal-delay-' + delay);
    });

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('vlr-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.vlr-reveal').forEach(function(el) {
      observer.observe(el);
    });
  }

  // ── Cursor Glow (desktop only) ──
  function initCursorGlow() {
    if (window.innerWidth < 768) return;
    var glow = document.createElement('div');
    glow.id = 'vlr-cursor-glow';
    glow.style.cssText = [
      'position:fixed',
      'pointer-events:none',
      'width:320px',
      'height:320px',
      'border-radius:50%',
      'background:radial-gradient(circle,rgba(201,169,110,0.10) 0%,transparent 70%)',
      'transform:translate(-50%,-50%)',
      'z-index:9999',
      'transition:opacity 0.3s ease',
      'opacity:0',
      'top:0',
      'left:0'
    ].join(';');
    document.body.appendChild(glow);

    document.addEventListener('mousemove', function(e) {
      glow.style.left = e.clientX + 'px';
      glow.style.top  = e.clientY + 'px';
      glow.style.opacity = '1';
    });
    document.addEventListener('mouseleave', function() {
      glow.style.opacity = '0';
    });
  }

  // ── Product card 3D tilt on hover (desktop only) ──
  function initCardTilt() {
    if (window.innerWidth < 768) return;
    document.querySelectorAll('.card-wrapper').forEach(function(card) {
      card.addEventListener('mousemove', function(e) {
        var rect = card.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width  - 0.5;
        var y = (e.clientY - rect.top)  / rect.height - 0.5;
        card.style.transform = 'translateY(-6px) rotateX(' + (-y * 5) + 'deg) rotateY(' + (x * 5) + 'deg)';
      });
      card.addEventListener('mouseleave', function() {
        card.style.transform = '';
      });
    });
  }

  // ── Init ──
  function init() {
    initReveal();
    initCursorGlow();
    initCardTilt();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
